import { encode as base64_encode } from "base-64";
import { postApi, baseURL } from "../components/Utility";
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
} from "mobx";
import config from "../config";
import { message } from "antd";

class FleetDaySummaryReportStore {
  fleetDaySummaryReport = [];
  loading = false;
  rootStore;
  remaning_vehicleId = ""
  last_record_timestamp = ""
  pythonReportMessage = false
  pythonReportErrorMessage = false

  constructor(rootStore) {
    makeObservable(this, {
      fleetDaySummaryReport: observable,
      loading: observable,
      // total : action,
      loadData: action,
      exportExcel: action,
      exportpdf: action,
      exportcsv: action,
      remaning_vehicleId: observable,
      last_record_timestamp: observable,
      pythonReportMessage: observable,
      pythonReportErrorMessage:observable
    //   exportxml: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, offset, limit, vehicleId, fromDate, toDate,pageNo }) {
    this.loading = true;
    // console.log(offset,limit)
    console.log("vehicle list");
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      page: pageNo,
    };

    if (config.pythonReport === 1) {
      // postData.companyId=10166
      // postData.vehicleId=[26375]
      // postData.filter = 2

      if (offset === 0) {
        postData.last_record_timestamp = ""
        postData.remaning_vehicleId = ""
      } else {
        postData.last_record_timestamp = this.last_record_timestamp
        postData.remaning_vehicleId = this.remaning_vehicleId
      }
      var response = await postApi.getClient('report').post("fleet_report/fleetDaySummary", postData);
      this.total = 500

    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
      .post("index.php?c=vehicle&a=daysummary", "postData=" + base64Input);
    }

    if (config.pythonReport === 1) {
      this.last_record_timestamp = response?.data?.data?.last_record_timestamp
      this.remaning_vehicleId = response?.data?.data?.remaning_vehicleId
    }

    // console.log(response?.data?.data?.TotalCount)
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.fleetDaySummaryReport = response?.data?.data?.daysummary;
    // console.log(response?.data?.data?.daysummary);
    this.loading = false;
  }

  async exportExcel(getData) {

      getData = { ...getData, language: "english" }
  
      try {

        await postApi.getClient().post("/fleet_report/fleetDaySummary/download/excel", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;

      } catch (error) {
        this.pythonReportErrorMessage = false;
        message.error("Failed to download the report. Please try again.")
      }

  }

  async exportpdf(getData) {
    
      getData = { ...getData, language: "english" }
      try {

        await postApi.getClient("report").post("/fleet_report/fleetDaySummary/download/pdf", getData, {
          responseType: "blob",
        });

        this.pythonReportMessage = true;

      } catch (error) {
        this.pythonReportErrorMessage = false;
        message.error("Failed to download the report. Please try again.")
      }
  }

  async exportcsv(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportdaysummarycsv&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      // "&int="+
      // getData.interval+
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }
//   async exportxml(getData) {
//     let lang = "english";
//     window.location.href =
//       baseURL +
//       "index.php?c=vehicle&a=exportdaysummaryxml&cid=" +
//       getData.companyId +
//       "&userId=" +
//       getData.userId +
//       "&vid=" +
//       getData.vehicleId +
//       // "&int="+
//       // getData.interval+
//       "&fD=" +
//       getData.fromDate +
//       "&tD=" +
//       getData.toDate +
//       "&colList=" +
//       getData.colList +
//       "&language=" +
//       lang;
//   }
}

export default FleetDaySummaryReportStore;
